import axios from 'axios';

export const sriBrowserPoolApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/sri-browser-pool/`,
    headers: {
        'Content-Type': 'application/json'
    }
})